import { __awaiter } from "tslib";
/**
 * log core !!!
 */
const hiuiLogUtilsUrl = 'https://r.haier.net/assets/overlay/dts-fe/pro-components-log-utils/index.js';
// @ts-ignore
const sendLog = (componentName = '', componentType = 'function') => {
    var _a;
    const report = window._HIUI_PRO_COMPONENTS_LOG_REPORT_;
    if (!componentName)
        return;
    if (report) {
        (_a = report.addLog) === null || _a === void 0 ? void 0 : _a.call(report, 'bwd_' + componentName, {
            eventType: 'blue-whale-components',
            componentType: 'bwd',
        });
    }
};
export default sendLog;
export function loadJs(url) {
    return __awaiter(this, void 0, void 0, function* () {
        if (window._hiui_pro_component_report)
            return;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.onload = function () {
            sendLog();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
}
const initLog = () => __awaiter(void 0, void 0, void 0, function* () {
    const report = window._HIUI_PRO_COMPONENTS_LOG_REPORT_;
    if (!report) {
        if (window._HIUI_PRO_COMPONENTS_LOG_ONLOAD_) {
            setTimeout(() => {
                sendLog();
            }, 1500);
            return;
        }
        window._HIUI_PRO_COMPONENTS_LOG_ONLOAD_ = 1;
        loadJs(hiuiLogUtilsUrl);
    }
    else {
        sendLog();
    }
});
initLog();
